import { useQuery } from '@tanstack/react-query'
import { FormattedMessage } from 'react-intl'

import { Currency } from '@/constants/currency'
import { queryKeys } from '@/constants/queryKeys'
import { getIdentity } from '@/domains/Business/api'
import { cn } from '@/lib/utils'
import { MotionDiv, Skeleton, Typography } from '@/shared/ui'

import { BalanceCard, MoveMoneyWidget } from '../../components'
import { useWallets } from '../../hooks'

import { FXRatesWidget } from './components/FXRatesWidget'
import { HomeBanners } from './components/HomeBanners'
import { TransactionsWidget } from './components/TransactionsWidget'

export const Home = () => {
  const {
    wallets,
    isPending: walletsPending,
    detailsPerCurrency,
  } = useWallets({
    showAll: true,
    staleTime: 0,
  })

  const userQuery = useQuery({
    queryKey: [queryKeys.getIdentity],
    queryFn: getIdentity,
    select: (data) => data.data,
  })

  return (
    <div className="flex w-full flex-col">
      <div className="flex w-full items-start justify-between">
        <div className="flex flex-col gap-2">
          <Typography variant="h3">
            <FormattedMessage id="dashboard.home.title" defaultMessage="Home" />
          </Typography>
          {userQuery.isPending ? (
            <Skeleton className="h-[21px] w-24" />
          ) : (
            <Typography className="text-neutral-gray-600">
              <FormattedMessage
                id="dashboard.home.subtitle"
                defaultMessage="Welcome, {name}!"
                values={{ name: userQuery.data?.firstName }}
              />
            </Typography>
          )}
        </div>

        <MoveMoneyWidget />
      </div>

      <div className="p-6" />

      <MotionDiv className="flex flex-col gap-12">
        {detailsPerCurrency && (
          <MotionDiv
            className={cn(
              'grid grid-cols-1 gap-6',
              detailsPerCurrency?.length > 1 && 'md:grid-cols-2',
            )}
          >
            {detailsPerCurrency
              .sort((_, b) => (b.currency === Currency.USDC ? 1 : -1))
              .map((detail) => (
                <BalanceCard
                  key={detail.currency}
                  isPending={walletsPending}
                  totalBalance={detail.totalBalance}
                  currency={detail.currency}
                  totalWallets={
                    wallets?.filter(
                      (wallet) => wallet.currency === detail.currency,
                    ).length
                  }
                />
              ))}
          </MotionDiv>
        )}

        <HomeBanners />

        <TransactionsWidget />

        <FXRatesWidget />
      </MotionDiv>
    </div>
  )
}
